<app-nav *ngIf="shouldShowNav()"></app-nav>
<router-outlet></router-outlet>
